import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-img',
  templateUrl: './view-img.component.html',
  styleUrls: ['./view-img.component.scss'],
  standalone: false,
})
export class ViewImgComponent {
  imageUrls: string[];
  selectedIndex: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewImgComponent>
  ) {
    this.imageUrls = data.imageUrls || [];
    this.selectedIndex = data.selectedIndex || 0;
  }

  selectImage(idx: number) {
    this.selectedIndex = idx;
  }

  onCancel() {
    this.dialogRef.close();
  }
}
